export const EMPLOYER_INFO_CURRENT_ROUTES = {
  get: '/employer-info/current',
  put: '/employer-info/current',
} as const;
